import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'

import CustomHelmet from '../components/CustomHelmet'
import Testimonials from '../components/_Redesign/Testimonials'
import AdmissionsSignup from '../components/_Redesign/AdmissionsSignup'
import Signup from '../components/_Redesign/Signup'
import Button from '../components/Button'

class HomePage extends React.Component {
    componentDidMount() {
        const hash = window.location.hash.substring(1)
        
        if( hash ) {
            const elemToShow = document.getElementById(hash)

            elemToShow ? elemToShow.scrollIntoView() : null
        }
    }

  render() {
    const { data: { page, fellows }, location } = this.props;
    const seoKeywords = page.seoData.keywords ? page.seoData.keywords.toString() : ``;

    return (
      <div className="home page-redesign">
        <CustomHelmet data={ page.seo } fallBack={ page } location={ location } />
        <div className="hero grid-2 grid-desktop-1 no-padding">
            <div className="item" style={{ background: 'url(https://images.ctfassets.net/j91b9gwu8s3q/4hWjDmsh7mjzi3HT99EAO7/397df0a7b2f60c74f3117ddf0f824ba9/New_Hero_Image__1_.png) center no-repeat', backgroundSize: 'cover' }}>
                <div className="content-wrapper">
                    <div className="content">
                        <h3 className="h3 color-white">Find your purpose<br/>and your power to . . .</h3>
                        <h1 className="h1 color-white">Make an impact</h1>
                    </div>
                </div>
            </div>
            <div className="item">
                <div className="content-wrapper">
                    <div className="content">
                        <h2 className="h2">Global Citizen Year is launching the generation of leaders our world needs now.</h2>
                    </div>
                </div>
            </div>
        </div>
        <section className="intro-section standard-spacing">
            <div className="item headline">
                <h3 className="h3">What is a global citizen year?</h3>
            </div>
            <div className="item content">
                <p><strong>Today’s education system shuttles kids from high school to college without opportunities to reflect on who they are, what the world needs, and how to build a meaningful life.</strong></p>
                <p>A Global Citizen Year re-imagines the transition into adulthood as what it has the potential to be: a transformation.  Students find their Global Citizen Years life-changing, parents say they’re priceless, and top colleges call them preferable.</p>
            </div>
        </section>
        <section className="bg-grey no-padding-right">
            <div className="block green-swipe-section standard-spacing">
                <h3 className="h1 large" style={{ position: 'relative', zIndex: 20 }}>The Future Is<br/>Up To You</h3>
                <h2 className="h2 no-transform">Global Citizen Year offers two experiences designed to launch the leaders our world needs now. Both programs select talented students who represent society’s diversity and equip them with the empathy, agency and global network to drive impact today -- and over the course of their lives.</h2>
                <img src="/images/green-strokes-tall.png" alt="Green stroke" className="strokes-top-right-corner" />
            </div>
            <div className="block block-learn-more-links bottom-spacer grid-4-3">
                <div className="item">
                    <div className="content-wrapper standard-spacing">
                        <div className="content">
                            <h4 className="h2 no-transform">Global Citizen Year Academy</h4>
                            <p>Our intensive leadership experience (delivered virtually) brings together determined young changemakers worldwide to build leadership skills for solving global challenges. The Academy is designed as a 7-10 hour per week commitment that adds an enriching layer of purpose to school, gap years, or work. Students enroll in our signature leadership course, join conversations with today’s most impactful changemakers, and receive one-on-one mentorship. At the end of the 12-week semester, students have confidence in the values that drive them and clarity on how to connect their purpose with the change they want to see in the world.</p>
                            <Button text="Learn About the Academy" href="/academy/" />
                            <p>Not sure which program is right for you? <a href="https://globalcitizenyear.typeform.com/to/qrmrqkgz/" className="hoverlink" target="_blank">Take the Quiz</a></p>
                        </div>
                    </div>
                </div>
                <div className="item" className="hide-tablet">
                    <img src="https://images.ctfassets.net/j91b9gwu8s3q/28wBHcxXOf6dZSSDggT2cH/dcf467aa6f1e4fc61ffefd1d629e4d16/ALF18_Cr_MarcusReichmann_Blink__1_.jpg" alt=""/>
                </div>
            </div>
            <div className="block block-learn-more-links bottom-spacer grid-3-4" style={{ position: 'relative' }}>
                <div className="item">
                    <img src="https://images.ctfassets.net/j91b9gwu8s3q/2c9hsCRTouSsOPfeY7EEyy/1c2b1b41bdb9ff93f5105438b307f13b/Ian_homepage__1_.jpg" alt=""/>
                </div>
                <div className="item">
                    <div className="content-wrapper standard-spacing">
                        <div className="content">
                            <h4 className="h2 no-transform">Global Citizen Year Fellowship</h4>
                            <p>Our flagship immersion experience enables exceptional high school graduates to live and work alongside the global majority in Brazil, Ecuador, or India. Fellows are chosen via a highly selective application process, and spend the equivalent of an academic year living with a family and apprenticing to local efforts advancing education, health, and sustainability. By staying longer and going deeper, Fellows learn languages through immersion, develop resilience living in their stretch zone, and become part of a community a world away from home. Fellows return with global skills and insights that shape their character and equip them to find shared solutions that advance the greater good.</p>
                            <Button text="Learn About the Fellowship" href="/fellowship/" />
                            <p>Not sure which program is right for you? <a href="https://globalcitizenyear.typeform.com/to/qrmrqkgz/" className="hoverlink" target="_blank">Take the Quiz</a></p>
                        </div>
                    </div>
                </div>
                <img src="/images/Blue-strokes-wide.png" alt="Green stroke" className="strokes-bottom-left-corner" />
            </div>
        </section>
        <section className="grid-2 grid-tablet-1 link-section-solid-color">
            <div className="item standard-spacing bg-black text-center">
                <p className="h2 no-transform text-center color-white">Are you a <span className="color-orange">parent</span> of a student interested in Global Citizen Year?</p>
                <a href="/parents/" className="hoverlink">Read the Parent Guide</a>
            </div>
            <div className="item standard-spacing bg-black-light text-center">
                <p className="h2 no-transform text-center color-white">Are you an <span className="color-orange">educator</span> looking to nominate students?</p>
                <a href="/for-educators/" className="hoverlink">Explore Opportunities</a>
            </div>
        </section>
        <section>
            <div className="block standard-spacing grid-2 grid-tablet-1 grid-gap-30">
                <div className="item headline">
                    <p className="h1 large">Why Global Citizen Year?</p>
                </div>
                <div className="item content-wrapper">
                    <div className="content">
                        <p className="large"><strong>The world needs a new generation of leaders who represent society’s diversity and bring curiosity, conviction and courage to overcoming our shared global challenges.<br/>
                        <br/>Global Citizen Year is the only program that recruits and selects the most promising future leaders (independent of financial circumstances) and helps them to develop the insights, skills, and networks needed to drive social impact over the course of their lives.</strong></p>
                        <div className="flex wrap-mobile button-wrapper">
                            <Button text="About Us" href="/about-us/" />
                            <Button text="Alumni Impact" className="transparent" href="/success-stories/" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="block block-list-details standard-spacing">
                <div className="item spacer"></div>
                <div className="item">
                    <div className="item">
                        <p><strong>Transformative Leadership Training</strong></p>
                        <p><em>We believe leadership is a practice, not a position.</em> Focusing exclusively on the formative transition into adulthood, our experiences help young people identify their power, pursue their purpose and reach their fullest potential. </p>
                    </div>
                    <div className="item">
                        <p><strong>Personalized Mentorship</strong></p>
                        <p><em>People become people through people.</em> Our talented crew of educators and innovators walk the walk -- aligning our lives with our convictions, and inspiring our students to do the same.  Additionally, with 100+ diverse mentors available for one-on-one support, students learn self-awareness,  accountability and agency: the foundations for a reflective and purposeful life.</p>
                    </div>
                    <div className="item">
                        <p><strong>Unparalleled Global Network</strong></p>
                        <p><em>Together, we go farther.</em> With an alumni community of 1,200 and growing, the Global Citizen Year network is a lifelong source of inspiration, opportunity, and support. Our alumni are in colleges and careers in over 60 countries where they’re already having an outsized impact on society; and they’re just getting started!</p>
                    </div>
                </div>
                <div className="item">
                    <div className="item">
                        <p><strong>Learning Beyond the Classroom</strong></p>
                        <p><em>School shouldn't interfere with your education.</em> Rather than limiting learning to the classroom, we take real-world experience and enrich it with a wrap-around of curriculum, coaching and a cohort. Our experiences are designed to build the true power skills of the 21st century, and our evidence shows we’re shaping values, perspectives and skills in ways classroom learning cannot.</p>
                    </div>
                    <div className="item">
                        <p><strong>Commitment to Equity & Inclusion</strong></p>
                        <p><em>Talent is universal, but opportunity is not.</em> We’re deliberately structured as a 501 (c ) 3 non-profit with social and racial justice - not profit - as our bottom line. We cast a wide net for talent and are proud to offer an admissions process that doesn’t rely on test scores, grades or a family’s financial circumstances. We give more financial aid than all other “gap year programs” combined (>$25 million since 2010) and 80% of students receive need-based financial aid to join us. By investing in promising young people who reflect our society’s diversity we’re changing the composition - and operating system - of our future leaders.</p>
                    </div>
                </div>
                <div className="item spacer"></div>
                <div className="item">
                    <a href="/financial-aid-tuition/" className="hoverlink">Learn more about Aid & Tuition</a>
                </div>
                <img src="/images/yellow-strokes.png" alt="Yellow stroke" className="redesign-strokes strokes-top-left-corner" />
                <img src="/images/yellow-strokes-tall.png" alt="Yellow stroke" className="redesign-strokes strokes-bottom-right-corner" />
            </div>
        </section>
        <section className="bg-grey standard-spacing">
            <div className="block block-press-logo-container standard-spacing">
                <div className="item headline content-wrapper">
                    <div className="content">
                        <h4 className="h3">Featured In</h4>
                        <a href="/press/" className="hoverlink">See all press stories</a>
                    </div>
                </div>
                <div className="item logo-container grid-3 grid-tablet-2">
                    <div className="item logo">
                        <img src="/images/press-icons/NY-Times.png" alt=""/>
                    </div>
                    <div className="item logo">
                        <img src="/images/press-icons/Goldman-Sachs.png" alt=""/>
                    </div>
                    <div className="item logo">
                        <img src="/images/press-icons/Washington-Post.png" alt=""/>
                    </div>
                    <div className="item logo">
                        <img src="/images/press-icons/Chronicle-of-Higher-Ed.png" alt=""/>
                    </div>
                    <div className="item logo">
                        <img src="/images/press-icons/Fast-Company.png" alt=""/>
                    </div>
                    <div className="item logo">
                        <img src="/images/press-icons/Shawn-Mendes-Foundation.png" alt=""/>
                    </div>
                    <div className="item logo">
                        <img src="/images/press-icons/USA-Today.png" alt=""/>
                    </div>
                    <div className="item logo">
                        <img src="/images/press-icons/PBS-News-Hour.png" alt=""/>
                    </div>
                    <div className="item logo">
                        <img src="/images/press-icons/Forbes.png" alt=""/>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <Testimonials
              title={page.testimonialsTitle}
              testimonials={page.testimonials}
            />
        </section>
        <section style={{ zIndex: '50', position: 'relative' }} id="signup">
            <Signup
              title={ page.admissionsRfiText ? page.admissionsRfiText : "Sign up for more!" }
              location={ this.props.location }
              color="black"
            />
        </section>
    </div>
    )
  }
}

export default HomePage

export const query = graphql`
  query HomePageQuery {
    fellows: contentfulFellowsParents {
  	  title
      link {
        text
        link
      }
      fellowsCards {
        storyPosition
        storyLocation
        quoteTitle
        attribution
        quoteText
        link
        articleImage {
          sizes(quality:100, maxWidth:400) {
                ...GatsbyContentfulSizes_withWebp
          }
          file {
            url
          }
          title
        }
      }
  	}
    page: contentfulHomePage {
      heroText
      heroTitle
      homeHeroSlides {
        photo {
            title
            sizes(quality:81, maxWidth:1800) {
                ...GatsbyContentfulSizes_withWebp
            }
        }
      }
      afterHeroTitle
      afterHeroText
      afterHeroItemOneTitle
      afterHeroItemOneText
      afterHeroItemTwoTitle
      afterHeroItemTwoText
      afterHeroItemThreeTitle
      afterHeroItemThreeText
      afterHeroLink {
        text
        link
      }
      issuesTitle
      issuesText
      issuesLink {
        text
        link
      }
      countryCards {
        title
        description
        backgroundImage {
            sizes(quality:100, maxWidth:800) {
                ...GatsbyContentfulSizes_withWebp
            }
          file {
            url
            fileName
            contentType
          }
          title
        }
        link
      }
      accessTitle
      accessText
		accessLogoList {
        file {
          url
          fileName
          contentType
        }
        title
      }
      testimonialsTitle
      testimonials {
        title
        quote
        featuredMedia {
            sizes(quality:100, maxWidth:800) {
                ...GatsbyContentfulSizes_withWebp
            }
          file {
            url
            fileName
            contentType
          }
          title
        }
        videoLink
        profileImage {
            sizes(quality:100, maxWidth:800) {
                ...GatsbyContentfulSizes_withWebp
            }
          file {
            url
            fileName
            contentType
          }
          title
        }
        link {
          text
          link
        }
      }
      alumniCards {
        title
        text {
          text
        }
      }
      alumniTitle
      alumniLink {
        text
        link
      }
      signupTitle
      seoData {
        pageTitle
        pageDescription {
          pageDescription
        }
        keywords
        openGraphTitle
        openGraphDescription {
          openGraphDescription
        }
        openGraphImage {
          file {
            url
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js